import { useQuery } from '@tanstack/react-query'
import { PURSE_KEYS } from '@/queries/program_purses/keys.ts'
import { getPurseAffiliations } from '@/queries/program_purses/requests.ts'

export type GetPurseAffiliationsParams = {
  programId: number
  purseId: number
}

const usePurseAffiliationsQuery = (
  request: GetPurseAffiliationsParams,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: PURSE_KEYS.PURSE_AFFILIATIONS(request.purseId, request.programId),
    queryFn: () => getPurseAffiliations(request),
    enabled,
  })
}

export default usePurseAffiliationsQuery
